import React, { useEffect } from "react";

import RechazoStep1 from '../../Resources/Images/Tutoriales/Rechazo/Rechazo-1.jpg';
import RechazoStep2 from '../../Resources/Images/Tutoriales/Rechazo/Rechazo-2.jpg';
import StepTutorial from './index-step';

function getSteps() {
    return ['Paso 1', 'Paso 2'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={RechazoStep1} text={[
                'Seleccionar los filtros correspondientes antes de realizar la búsqueda',
                'Presione el botón Buscar'
            ]} />;
        case 1:
            return <StepTutorial image={RechazoStep2} text={[
                'Al hacer click en el botón “Descargar” podrás exportar el listado de rechazos a Excel'
            ]} />;
        default:
            return '¡Tutorial completado!';
    }
}

export function Rechazo({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Paso a paso para utilizar la búsqueda de Rechazos</h2>

            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
